export default {
  free: {
    en: 'Free',
  },
  alwaysFree: {
    en: 'Always free',
  },
  subTotal: {
    en: 'Subtotal',
  },
  total: {
    en: 'Total',
  },
  surcharge: {
    en: 'Premium product surcharge',
  },
  surchargeNote: {
    en: 'This surcharge will be deducted from<br />your account after 12 hours',
  },
}
